function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M595.56,311.64a16.79,16.79,0,0,0-23.57,0L542.53,341.1l-29.46-29.46a16.8,16.8,0,1,0-23.57,23.57L519,364.67,489.5,394.13a16.8,16.8,0,1,0,23.57,23.57l29.46-29.45L572,417.7a16.8,16.8,0,1,0,23.57-23.57L566.1,364.67l29.46-29.46a16.79,16.79,0,0,0,0-23.57Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M143.25,158.26H420.84c25,0,45.25,25,45.25,45.22a45.24,45.24,0,0,1-45.25,45.22H143.25c-25,0-45.25-25-45.25-45.22a45.24,45.24,0,0,1,45.25-45.22Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M420.84,319.2H143.25a45.25,45.25,0,0,0,0,90.5H420.84a45.25,45.25,0,0,0,0-90.5Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M511,261.52a16.79,16.79,0,0,0,28.5,0l60.09-98.79a16.8,16.8,0,1,0-28.5-17.13l-45.87,75.15-9.68-16h0A16.81,16.81,0,0,0,487,222.1Z"
});

var SvgLinkToBrand = function SvgLinkToBrand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 700 700",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkToBrand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkToBrand.3003d336.svg";
export { ForwardRef as ReactComponent };